export enum ShapeSeatTypes {
  WHEELCHAIR = 'Wheelchair',
  LOVESEAT_LEFT = 'LoveSeatLeft',
  LOVESEAT_RIGHT = 'LoveSeatRight',
  CON_SEAT = 'ConSeat',
  SEAT_WITH_FOOTSTOOL = 'SeatWithFootstool',
  SEAT = 'Seat',
  NORMAL_CHAIR = 'NormalChair',
  DISABLED = 'Disabled',
  NONE = 'None'
}
